import { motion } from "framer-motion";
import ButtonSvg from "../assets/svg/ButtonSvg";

const Button = ({ className = "", href, children, ...props }) => {
  if (href) {
    return (
      <motion.a
        href={href}
        className={`relative inline-flex items-center justify-center h-12 px-6 rounded-xl font-semibold ${className}`}
        whileHover={{ scale: 1.001 }}
        whileTap={{ scale: 0.999 }}
        transition={{ duration: 0.1 }}
        {...props}
      >
        <span className="relative z-10">{children}</span>
        <div className="absolute z-0">
          {ButtonSvg()}
        </div>
      </motion.a>
    );
  }

  return (
    <motion.button
      className={`relative inline-flex items-center justify-center h-12 px-6 rounded-xl font-semibold ${className}`}
      whileHover={{ scale: 1.001 }}
      whileTap={{ scale: 0.999 }}
      transition={{ duration: 0.1 }}
      {...props}
    >
      <span className="relative z-10">{children}</span>
      <div className="absolute z-0">
        {ButtonSvg()}
      </div>
    </motion.button>
  );
};

export default Button;
